import React, { ReactElement } from 'react';

import MuiSlide, { SlideProps } from '@material-ui/core/Slide';

interface Props extends SlideProps {
  children: ReactElement;
}

export function Slide(props: Props): JSX.Element {
  const { children, ...rest } = props;

  return <MuiSlide {...rest}>{children}</MuiSlide>;
}
